import { Component, EventEmitter, Input, Output } from '@angular/core';

type actionBtnType = 'previous' | 'next';

@Component({
  selector: 'shared-pagination',
  standalone: false,
  template: `
    <!-- Pagination Section -->
    <div class="flex justify-{{ xPosition }} items-center gap-3 w-full">
      <button
        (click)="handleAction('previous')"
        class="inline-flex gap-0.5 items-center text-white bg-primary text-sm py-1 px-2 rounded active:bg-primary transition-all"
      >
        <img
          src="assets/icons/Forward-Icon.svg"
          alt="previous"
          class="w-5 aspect-square rotate-180"
        />
        Previous
      </button>
      <div class="space-x-1">
        @for (page of pageNumbers; track $index) { @if(page > 0) {
        <button
          (click)="handlePageChange(page)"
          class="p-1 rounded w-7 transition-all duration-200 {{
            currentPage == page ? 'bg-primary text-primary-foreground' : ''
          }}"
        >
          {{ page }}
        </button>
        } }
      </div>
      <button
        (click)="handleAction('next')"
        class="inline-flex gap-0.5 items-center text-white bg-primary text-sm py-1 px-2 rounded active:bg-primary transition-all"
      >
        Next
        <img
          src="assets/icons/Forward-Icon.svg"
          alt="next"
          class="w-5 aspect-square"
        />
      </button>
    </div>
  `,
  styles: ``,
})
export class PaginationComponent {
  @Input() xPosition: 'start' | 'center' | 'end' = 'end';
  @Input({ required: true }) totalNoOfItems!: number;
  @Input({ required: true }) currentPage!: number;
  @Input({ required: true }) itemsPerPage!: number;
  @Output() pageChanged = new EventEmitter<number>();
  totalPages = 0;

  ngOnChanges(): void {
    this.totalPages = Math.ceil(this.totalNoOfItems / this.itemsPerPage);
  }

  get pageNumbers() {
    const startPage =
      this.totalPages - this.currentPage > 2
        ? Math.max(1, this.currentPage - 2)
        : this.totalPages - 4;
    const endPage = Math.min(this.totalPages, startPage + 4);
    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  }

  handlePageChange(page: number): void {
    if (page != this.currentPage && page > 0 && page <= this.totalPages) {
      this.currentPage = page;
      this.pageChanged.emit(page);
    }
  }

  handleAction(type: actionBtnType): void {
    if (type == 'previous') {
      this.handlePageChange(this.currentPage - 1);
    }
    if (type == 'next') {
      this.handlePageChange(this.currentPage + 1);
    }
  }
}
